export const EDUCATION_TOOLTIP_STORAGE_KEY = 'brief_edifft_education_tooltip';
export const GIF_URL_PREFIX =
    'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/6480a6a1a305f9290781d8c0315cb743';
